import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';
import { ITag } from '../layout/nomenclatoare/setari-proiecte/taguri-proiecte/taguri-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private basePath = environment.interop.basePath;

    private getSectiuniProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteSectiuni.list;
    private getCategoriiProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteCategorii.listActive;
    private filterCategoriiProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteCategorii.filter;
    private getTaguriProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteTag.listActive;
    private typeheadTagProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteTag.typehead;
    private providerProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteProvider.listActive;
    private motiveProiecteUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteMotiv.listActive;
    private getOperatoriUrl = this.basePath + environment.interop.monitoring.nomenclatoare.proiecteOperatori.list;

    private getDirectiiActiveUrl = this.basePath + environment.interop.monitoring.nomenclatoare.directie.listActive;
    private getCompartimenteActiveUrl = this.basePath + environment.interop.monitoring.nomenclatoare.compartiment.listActive;
    private getCompartimentByDirectieUrl = this.basePath + environment.interop.monitoring.nomenclatoare.compartiment.listByDirectie;
    private getFunctiiUrl = this.basePath + environment.interop.monitoring.nomenclatoare.functiiUser.list;
    private getFunctiiActiveUrl = this.basePath + environment.interop.monitoring.nomenclatoare.functiiUser.listActive;

    constructor(private http: HttpClient) { }

    getSectiuniProiecte() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getSectiuniProiecteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_section,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get sectiuni:', error);
                    return throwError(error);
                })
            );
    }

    getCategoriiProiecte() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCategoriiProiecteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get categorii active:', error);
                    return throwError(error);
                })
            );
    }

    filterCategoriiProiecte(section_id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.filterCategoriiProiecteUrl + section_id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get categorii by section:', error);
                    return throwError(error);
                })
            );
    }

    getTaguriProiecte() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTaguriProiecteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get taguri active:', error);
                    return throwError(error);
                })
            );
    }

    typeheadTagProiecte(data: { name: string }) {
        return this.http
            .post<{ errors: boolean; data: { tags: ITag[] }; status_code: number }>(
                this.typeheadTagProiecteUrl, data
            )
            .pipe(
                map((response) => response.data.tags.map((item: ITag) => ({
                    id: item.id,
                    name: item.name,
                }))
                ),
                catchError((error) => {
                    console.error('Error in get tags:', error);
                    return throwError(error);
                })
            );
    }

    getProviderProiecte() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.providerProiecteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get provider:', error);
                    return throwError(error);
                })
            );
    }

    filterProviderProiecte(provider_type: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                `${this.providerProiecteUrl}?provider_type=${provider_type}`
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get provider by type:', error);
                    return throwError(error);
                })
            );
    }

    getMotiveProiecte() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.motiveProiecteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get motive active:', error);
                    return throwError(error);
                })
            );
    }

    getDirectiiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente by directie:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectie(directieId: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimentByDirectieUrl + directieId
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente by directie:', error);
                    return throwError(error);
                })
            );
    }

    getFunctii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getFunctiiUrl,
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get functii:', error);
                    return throwError(error);
                })
            );
    }

    getFunctiiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getFunctiiActiveUrl,
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get functii active:', error);
                    return throwError(error);
                })
            );
    }

    getOperatori() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getOperatoriUrl,
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_user,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get operatori:', error);
                    return throwError(error);
                })
            );
    }
}
